/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M50 26c-17.895 0-33.77 8.973-43.625 22.812a2.006 2.006 0 000 2.344C16.23 64.996 32.105 74 50 74s33.77-9.004 43.625-22.844c.504-.7.504-1.645 0-2.344C83.77 34.972 67.895 26 50 26zm0 4c16.031 0 30.238 7.832 39.438 20C80.238 62.16 66.024 70 50 70s-30.238-7.84-39.438-20C19.762 37.832 33.968 30 50 30zm0 6c-7.707 0-14 6.293-14 14s6.293 14 14 14 14-6.293 14-14-6.293-14-14-14zm0 4c5.547 0 10 4.453 10 10s-4.453 10-10 10-10-4.453-10-10 4.453-10 10-10z"/>'
  }
})
